import PricingScene from '../../scenes/Pricing';

export default PricingScene;
